export default __webpack_public_path__ + "static/media/home-restaurant-img-15.04527df5.jpg";